import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL, BUILD_PLATFORM, PLATFORM_PWA, PLATFORM_ANDROID, PLATFORM_IOS } from '../constants';
import { Divider, Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
// import { downloadCsv, downloadCsvAndroid } from '../helpers/Helpers';
import CampaignIcon from '@mui/icons-material/Campaign';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { formatDateTime } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));
  
function OfficePostsClient (props) {
    const [open, setOpen] = React.useState(false);
    const [message, setMessaage] = useState("fetching data...");
    const [posts, setPosts] = useState([]);

    const dialogContentRef = React.useRef(null);

    const handleClickOpen = () => {
        setOpen(true);
        fetchPosts();
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const fetchPosts = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/list-office-posts/' + props.officeId + '/100/desc', {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data.data);
            setPosts(data.data);
            if (data.data.length < 1) setMessaage("No advisories yet");
        })
        .catch(err => console.error(err));
    };

    return (
        <React.Fragment>
            {props.hideButton ? null :
                <IconButton
                    onClick={handleClickOpen}
                    size="small"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                    <CampaignIcon fontSize='small' sx={{ color: 'gray' }}/>
                    <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>View All Advisories</Typography>
                </IconButton>
            }
            
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",
                      },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={0}>
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                            Advisories
                        </Typography>
                        <Typography variant="body1">
                            {props.officeName}
                        </Typography>
                    </Stack>
                </DialogTitle>
                
                <DialogContent 
                    sx={{ p: 1, minHeight: "300px" }} 
                    dividers 
                    ref={dialogContentRef}   // attach ref
                >
                    {posts.map(post => {

                    return (
                        <Box key={post.id} sx={{ p:1, display: 'flex', justifyContent: 'center' }}>
                            <Card sx={{ minWidth: 275, backgroundColor: 'background.paper', boxShadow: 6, borderRadius: 2 }}>
                                <CardContent>
                                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 13 }}>
                                        posted: {formatDateTime(post.created_at_local)}
                                        {post.created_at_local !== post.updated_at_local ? 
                                            <>
                                                <br />edited: {formatDateTime(post.updated_at_local)}
                                            </>
                                        : null}
                                    </Typography>
                                    <Typography style={{whiteSpace: "pre-line", verticalAlign: "bottom"}} variant="body1" component="div">
                                        {post.content}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                    );
                })}
 
                    {posts.length < 1 ? 
                        <Box sx={{ p:1, display: 'flex', justifyContent: 'center' }}>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="body2" component="div">{ message }</Typography> 
                        </Box>
                    : null}
                </DialogContent>

                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>

        </React.Fragment>
    );
}

export default OfficePostsClient;
